import axios from "axios"

const instance = axios.create({
    baseURL: "https://image-uploader-mern-stack.herokuapp.com", // backend url
  });
  
  export default instance;